// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsVerificationStatusForm_heading__777LI","form":"ReportingDetailsVerificationStatusForm_form__rk2iV"};